// System directivies

'use client';

// System dependencies

import React from 'react';
import { Provider } from 'react-redux';

// Application dependencies

import store from '@/redux/store';

// Props

interface ReduxProviderProps {
  children: React.ReactNode;
}

const ReduxProvider: React.FC<ReduxProviderProps> = ({ children }) => {
  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return <Provider store={store}>{children}</Provider>;
};

export default ReduxProvider;
